export default {
    mimo: 'mapbox://styles/jung-gent/ckyvgd44n003714pdybkhyq4j',
    dark: '',
    light: 'mapbox://styles/jung-gent/ckz2vtrqf001x16o6dil4iacp'
}